import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const FlowsService = {
  getFlows: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}bots/flows`);
  },
  getFlowsByAccount: (data: any) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}bots/flows/${data}`);
  },
  saveFlow: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/flows`, data);
  },
  editFlow: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}bots/flows`, data);
  },
  changeStatusFlow: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}bots/flows/${data.bot_id}`, {
      status: data.status
    });
  },
  deployFlow: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}bots/nodes/deploy`, data);
  }
};
